import React, {
  useCallback,
  useMemo,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Edit } from '@material-ui/icons';
import { parseISO, format } from 'date-fns';
import { assign } from 'lodash';

import { UnidataTable } from '~/components';
import { t, can } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import dateTime from '~/hooks/DateTime';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/checkxmlnfrecebimentonf/actions';

import { Heading, Form } from './components';
import VericaXMLChegou from './components/VericaXMLChegou';

function Checkxmlnfrecebimentonf() {
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const redux = useSelector((state) => state.checkxmlnfrecebimentonf);

  const buttons = [];

  const [serverDate, setServerDate] = useState(null);
  const [modal, setModal] = useState(false);
  const [params, setParams] = useState({});
  const [isUpdate, setIsUpdate] = useState(false);

  const [isFinalizado, setIsFinalizado] = useState(false);

  const [openedVericaXMLChegou, setOpenedVericaXMLChegou] = useState(false);

  const [tokenUuidDescarganf, setTokenUuidDescarganf] = useState('');
  const [
    habilitafotonotafiscalposto,
    setHabilitafotonotafiscalposto,
  ] = useState('');
  const [jatiroufotodescarganf, setJatiroufotodescarganf] = useState('');
  const [nfdescarganf, setNfdescarganf] = useState('');

  const token = useSelector((state) => state.auth);

  const appUrl = `${
    window.location.host
  }/fotonf?id=${tokenUuidDescarganf}&token=${JSON.stringify(
    token.token
  ).replace(/^["']|["']$/g, '')}`;

  const header = useMemo(() => {
    const data = [
      {
        id: 'datahorainiciodescarganf',
        label: t('s.operacao.recebimento.datahorainiciodescarga'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: {
          type: 'initialdatetime',
          defaultValue: serverDate
            ? serverDate
                .clone() // evita modificar o original
                .subtract(7, 'day') // subtrai 1 dia
                .set({ hour: 0, minute: 0, second: 0 }) // zera o horário
                .format('DD/MM/YYYY HH:mm:ss')
            : '',
          // defaultValue: serverDate
          //   ? serverDate
          //     .set({ hour: 0, minute: 0, second: 0 })
          //     .format('DD/MM/YYYY HH:mm:ss')
          //   : '',
        },
      },
      {
        id: 'datahorafimdescarganf',
        label: t('s.operacao.recebimento.datahorafimdescarga'),
        formatted: (value) =>
          value ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : '',
        filter: {
          type: 'finaldatetime',
          defaultValue: serverDate
            ? serverDate
                .set({ hour: 23, minute: 59, second: 59 })
                .format('DD/MM/YYYY HH:mm:ss')
            : '',
        },
      },
      {
        id: 'codigonomeposto',
        label: t('s.operacao.recebimento.nomeposto'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'nfdescarganf',
        label: t('s.operacao.recebimento.nfdescarga'),
        filter: {
          type: 'text',
        },
        align: 'right',
      },
      // {
      //   id: 'finalizadadescarganf',
      //   label: t('s.configuracao.posto.statusposto'),
      //   formatted: (value) => status.find((s) => s.label === value).value ?? '',
      //   // filter: {
      //   //   type: 'select',
      //   //   options: status,
      //   //   defaultValue: '0',
      //   // },
      // },
      {
        id: 'volumenfdescarganf',
        label: t('s.operacao.recebimento.volumenfdescarga'),
        filter: {
          type: 'number',
        },
        align: 'right',
      },
      {
        id: 'placactdescarganf',
        label: t('s.operacao.recebimento.placactdescarga'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'codigousuario',
        label: t('s.operacao.recebimento.codigousuario'),
        filter: {
          type: 'text',
        },
      },
    ];

    return data;
  }, [serverDate]);

  // Open Modal Edit
  const handleOpenModalEdit = useCallback((values) => {
    setModal(true);
    setParams(values);
  }, []);

  // Close Modal Edit
  const handleCloseModalEdit = useCallback(() => {
    setModal(false);
    setParams({});

    dispatch(recordFiltering(redux.params));
  }, [redux]);

  const handleToggleQRcodeNFOpen = () => {
    setOpenedVericaXMLChegou((value) => !value);
  };

  const handleToggleFotoQRcodeNFOpen = () => {
    setOpenedVericaXMLChegou((value) => !value);
    dispatch(recordFiltering(assign(redux?.params, params)));
  };

  const handleCloseVerifica = () => {
    setOpenedVericaXMLChegou((value) => !value);
    dispatch(recordFiltering(assign(redux?.params, params)));
  };

  const actionsButtons = useMemo(() => {
    const buttons = [];
    isFinalizado && // TEste
      buttons.push({
        title: t('s.geral.botaoalterar'),
        action: (value) => handleOpenModalEdit(value),
        icon: <Edit />,
      });

    return buttons;
  }, [
    isUpdate,
    isFinalizado,
    habilitafotonotafiscalposto,
    jatiroufotodescarganf,
  ]);

  const actions = useMemo(
    () =>
      isUpdate
        ? [
            {
              title: t('s.geral.botaoalterar'),
              action: (value) => handleOpenModalEdit(value),
              icon: <Edit />,
            },
          ]
        : [],
    [isUpdate, habilitafotonotafiscalposto]
  );

  useEffect(() => {
    async function handleGetDate() {
      const date = await dateTime();
      setServerDate(date);
    }

    handleGetDate();
  }, []);

  useEffect(() => {
    if (modal) {
      formRef.current.openModal();
    }
  }, [modal]);

  const fieldlist = [
    'datahorainiciodescarganf',
    'datahorafimdescarganf',
    'codigonomeposto',
    'nfdescarganf',
    'volumenfdescarganf',
    'placactdescarganf',
    'codigousuario',
  ];

  const substituirHeader = {
    datahorainiciodescarganf: t(
      's.operacao.recebimento.datahorainiciodescarga'
    ),
    datahorafimdescarganf: t('s.operacao.recebimento.datahorafimdescarga'),
    codigonomeposto: t('s.operacao.recebimento.nomeposto'),
    nfdescarganf: t('s.operacao.recebimento.nfdescarga'),
    volumefdescarganf: t('s.operacao.recebimento.volumenfdescarga'),
    placactdescarganf: t('s.operacao.recebimento.placactdescarga'),
    codigousuario: t('s.operacao.recebimento.codigousuario'),
  };

  return (
    <>
      {serverDate && (
        <UnidataTable
          fixed
          create={false}
          update={false}
          redux={redux}
          header={header}
          read={recordFiltering}
          find={findData}
          remove={deleteData}
          toolbar={Heading}
          actions={actionsButtons}
          // actions={actions}
          detach="nomeposto"
          keys={['iddescarganf', 'idposto']}
          onRow={({
            iddescarganf,
            idposto,
            finalizadadescarganf,
            tokenuuiddescarganf,
            habilitafotonotafiscalposto,
            jatiroufotodescarganf,
            nfdescarganf,
          }) => {
            setIsUpdate(Number(finalizadadescarganf) === 0);

            setIsFinalizado(Number(finalizadadescarganf) === 1);

            setTokenUuidDescarganf(tokenuuiddescarganf);
            setHabilitafotonotafiscalposto(habilitafotonotafiscalposto);
            setJatiroufotodescarganf(jatiroufotodescarganf);
            // setIddescarganf(iddescarganf);
            // setIdposto(idposto);
            setNfdescarganf(nfdescarganf);
          }}
          pdf
          excel
          onExport={(formato) =>
            handleExportGeneric({
              endpoint: 'checkxmlnfrecebimentonf',
              formato,
              fields: fieldlist,
              headers: substituirHeader,
              redux,
              ordination: redux.params.ordination,
              orderfield: redux.params.orderfield,
              title: 'Relatório de Recebimento pendente para Integração',
            })
          }
        />
      )}

      {modal && (
        <Form
          ref={formRef}
          onCloseModal={handleCloseModalEdit}
          formEdit={params}
        />
      )}

      <VericaXMLChegou
        open={openedVericaXMLChegou}
        onCloseModal={handleCloseVerifica}
      />
    </>
  );
}

export default Checkxmlnfrecebimentonf;
